import { useState } from 'react';

/** Archive with an inline are-you-sure (browser dialogs are blocked in
    the Zoom webview; an inline confirm works everywhere). Reversible —
    unarchive is one click. Server-side flag shared across all staff. */
export function ArchiveButton({ isArchived, onToggle }: { isArchived: boolean; onToggle: () => void }) {
  const [confirming, setConfirming] = useState(false);
  if (isArchived) {
    return (
      <button type="button" className="btn-secondary shrink-0 !py-1 !text-xs" onClick={onToggle}>
        Unarchive
      </button>
    );
  }
  if (!confirming) {
    return (
      <button type="button" className="btn-secondary shrink-0 !py-1 !text-xs" onClick={() => setConfirming(true)}>
        Archive
      </button>
    );
  }
  return (
    <span className="flex shrink-0 items-center gap-1 text-xs">
      <span className="text-gray-600">Sure?</span>
      <button
        type="button"
        className="rounded bg-red-600 px-2 py-0.5 font-medium text-white hover:bg-red-700"
        onClick={() => {
          setConfirming(false);
          onToggle();
        }}
      >
        Archive
      </button>
      <button type="button" className="btn-secondary !py-0.5 !text-xs" onClick={() => setConfirming(false)}>
        Cancel
      </button>
    </span>
  );
}
